import './Users.css';
import api from '../api.js';
import { useEffect, useState } from "react";
import plus from "../imgs/plus.svg";
import edit from "../imgs/pen.svg";
import { fmtDateTime } from '../utils/format';

export default function Users() {
    const [users, setUsers] = useState([]);
    const [partners, setPartners] = useState([]);
    const [error, setError] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("Админ");
    const [partnerId, setPartnerId] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [modalError, setModalError] = useState("");
    const [modalMessage, setModalMessage] = useState("");

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [newLogin, setNewLogin] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newRole, setNewRole] = useState(0);
    const [newName, setNewName] = useState("");
    const [newEmail, setNewEmail] = useState("");
    const [newPhoneNumber, setNewPhoneNumber] = useState("");
    const [createMessage, setCreateMessage] = useState("");
    const [createError, setCreateError] = useState("");

    const me = JSON.parse(localStorage.getItem("me"));
    const myLogin = me?.userInfo?.login;

    useEffect(() => {
        document.title = "Пользователи - WAve";
        fetchUsers();
        fetchPartners();
    }, []);

    const fetchUsers = async () => {
        try {
            // const token = localStorage.getItem("token");
            const res = await api.get("/api/users/list-users", {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setUsers(res.data);
        } catch {
            setError("Ошибка загрузки пользователей");
        }
    };


    const fetchPartners = async () => {
        try {
            // const token = localStorage.getItem("token");
            const res = await api.get("/api/partners/list", {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            setPartners(res.data.filter(p => p.status === "Активен"));
        } catch {
            setError("Ошибка загрузки партнеров");
        }
    };


    const openModal = (user) => {
        setSelectedUser(user);
        setLogin(user.login);
        setPassword("");
        setRole(user.role);
        setName(user.name);
        setEmail(user.email);
        setPhoneNumber(user.phoneNumber);

        if (user.partnerId != null) {
            setPartnerId(Number(user.partnerId));
        } else if (user.partnerName) {
            const found = partners.find(p => p.name === user.partnerName);
            setPartnerId(found ? Number(found.id) : null);
        } else {
            setPartnerId(null);
        }

        setModalError("");
        setModalMessage("");
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedUser(null);
        setPartnerId("");
    };

    const handleEditUser = async (e) => {
        e.preventDefault();
        setModalError("");
        setModalMessage("");

        try {
            // const token = localStorage.getItem("token");
            const payload = {
                login: selectedUser.login,
                changedLogin: login,
                password: password || null,
                role,
                name,
                email,
                phoneNumber,
                partnerId: role === "Партнер" ? partnerId : null,
            };
            const res = await api.patch("/api/users/edit-user", payload, {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });

            if (res.status === 200) {
                setModalMessage("Пользователь обновлён");
                fetchUsers();
            }
        } catch (err) {
            setModalError(err?.response?.data || "Ошибка редактирования");
        }
    };


    const handleCreateUser = async (e) => {
        e.preventDefault();
        setCreateMessage("");
        setCreateError("");

        try {
            // const token = localStorage.getItem("token");
            const payload = {
                login: newLogin,
                password: newPassword,
                role: newRole,
                name: newName,
                email: newEmail,
                phoneNumber: newPhoneNumber,
            };
            const res = await api.post("/api/users/create-user", payload, {
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });

            if (res.status === 200) {
                setCreateMessage("Пользователь успешно создан");
                setNewLogin("");
                setNewPassword("");
                setNewRole(0);
                setNewName("");
                setNewEmail("");
                setNewPhoneNumber("");
                fetchUsers();
            }
        }
        catch (err) {
            // пытаемся взять сообщение с сервера
            const serverMessage = err.response?.data || err.response?.data?.message;
            if (serverMessage && serverMessage !== "") {
                setCreateError(serverMessage);
            } else {
                setCreateError("Ошибка создания пользователя. Проверьте поля.");
            }
        };
    }

    const handleBlockUser = async (loginToBlock) => {
        try {
            // const token = localStorage.getItem("token");
            await api.patch("/api/users/block-user", null, {
                params: { login: loginToBlock },
                // headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            fetchUsers();
        } catch (err) {
            setError(err.response?.status === 403 ? "Нет прав на блокировку" : "Ошибка блокировки");
        }
    };

    const closeCreateModal = () => {
        setIsCreateModalOpen(false);
        setNewLogin("");
        setNewPassword("");
        setNewRole(0);
        setNewName("");
        setNewEmail("");
        setNewPhoneNumber("");
    };

    return (
        <div className="users-main">
            {error && <p className="error">{error}</p>}

            <div className="tableWrapperUsers">
                <div className="topBar">
                    <button className="createUser" onClick={() => setIsCreateModalOpen(true)}>
                        <p>Создать пользователя</p>
                        <img src={plus} alt="plus" />
                    </button>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Логин</th>
                            <th>Роль</th>
                            <th>Партнер</th>
                            <th>Статус</th>
                            <th>Создан</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(u => (
                            <tr key={u.login}>
                                <td>{u.login}</td>
                                <td>{u.role}</td>
                                <td>{u.partnerName || "-"}</td>
                                <td>
                                    <button
                                        className={(u.status !== "Деактивирован" && u.login !== myLogin) ? "status-button" : "status-button-disabled"}
                                        disabled={u.status === "Деактивирован"}
                                        onClick={() => u.login !== myLogin && handleBlockUser(u.login)}
                                        onMouseEnter={e => { if (u.status !== "Деактивирован" && u.login !== myLogin) e.currentTarget.innerText = "Заблокировать"; }}
                                        onMouseLeave={e => { if (u.status !== "Деактивирован" && u.login !== myLogin) e.currentTarget.innerText = u.status; }}
                                    >
                                        {u.status}
                                    </button>
                                </td>
                                <td className="nowrap">{fmtDateTime(u.created_at)}</td>
                                <td className='editDesktop'>
                                    {u.status !== "Деактивирован" && <button className="editUser" type="button" onClick={() => openModal(u)}>Редактировать</button>}
                                </td>
                                <td className='editMobile'>
                                    {u.status !== "Деактивирован" && <button className="editUser" type="button" onClick={() => openModal(u)}><img className='editVector' src={edit} /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {isModalOpen && (
                <div className="modalOverlay">
                    <div className="modal">
                        <div className='modalTop'>
                            <h3>Редактирование пользователя</h3>
                            <button type="button" onClick={closeModal}></button>
                        </div>
                        <form onSubmit={handleEditUser}>
                            <input value={login} onChange={e => setLogin(e.target.value)} required placeholder="Логин" />
                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Пароль" />
                            {selectedUser.login !== myLogin &&
                                <select value={role} onChange={e => setRole(e.target.value)}>
                                    <option value="Админ">Админ</option>
                                    <option value="Партнер">Партнер</option>
                                </select>
                            }
                            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Имя" />
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" />
                            <input type="text" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} placeholder="Телефон" />
                            {role === "Партнер" &&
                                <select
                                    value={partnerId !== null ? String(partnerId) : ""}
                                    onChange={e => setPartnerId(e.target.value ? Number(e.target.value) : null)}
                                >
                                    <option value="">Партнер не указан</option>
                                    {partners.map(p => (
                                        <option key={p.id} value={String(p.id)}>{p.name}</option>
                                    ))}
                                </select>
                            }
                            {modalMessage && <p className="success">{modalMessage}</p>}
                            {modalError && <p className="error">{modalError}</p>}
                            <div className='buttonsModal'>
                                <button type="submit" className='saveUser'>Сохранить</button>
                                <button type="button" className='cancelUser' onClick={closeModal}>Отмена</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isCreateModalOpen && (
                <div className="modalOverlay">
                    <div className="modal">
                        <form onSubmit={handleCreateUser}>
                            <div className='modalTop'>
                                <h3>Создать пользователя</h3>
                                <button type="button" onClick={closeCreateModal}></button>
                            </div>
                            <input value={newLogin} onChange={e => setNewLogin(e.target.value)} required placeholder="Логин" />
                            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required placeholder="Пароль" />
                            <select value={newRole} onChange={e => setNewRole(e.target.value)}>
                                <option value={0}>Админ</option>
                                <option value={1}>Партнер</option>
                            </select>
                            <input value={newName} onChange={e => setNewName(e.target.value)} required placeholder="Имя" />
                            <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} required placeholder="Email" />
                            <input type="tel" value={newPhoneNumber} onChange={e => setNewPhoneNumber(e.target.value)} required placeholder="Телефон" />
                            {createMessage && <p className="success">{createMessage}</p>}
                            {createError && <p className="error">{createError}</p>}
                            <div className='buttonsModal'>
                                <button type="submit" className='saveUser'>Создать</button>
                                <button type="button" className='cancelUser' onClick={closeCreateModal}>Отмена</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}